import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';

import { CowListItem, ProductionSummary } from '../models/production.model';

@Injectable({
  providedIn: 'root',
})
export class ProductionReportService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/herd/secure/report/production';

  getSummary(date: string): Observable<ProductionSummary> {
    return this.http.get<ProductionSummary>(`${this.baseUrl}/summary?date=${date}`);
  }

  getCows(date: string): Observable<CowListItem[]> {
    return this.http.get<CowListItem[]>(`${this.baseUrl}/cows?date=${date}`);
  }
}
